/**
 * @author Dmitriy Malakhov
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withExternalProps = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var withExternalProps = exports.withExternalProps = function withExternalProps(channel) {
  return function (WrappedComponent) {
    var contextTypes = _defineProperty({}, channel, _propTypes2.default.func);

    var WithExternalProps = function (_Component) {
      _inherits(WithExternalProps, _Component);

      function WithExternalProps(props) {
        _classCallCheck(this, WithExternalProps);

        var _this = _possibleConstructorReturn(this, (WithExternalProps.__proto__ || Object.getPrototypeOf(WithExternalProps)).call(this, props));

        _this.state = {
          externalProps: {}
        };
        _this._unsubscribe = null;
        return _this;
      }

      _createClass(WithExternalProps, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _this2 = this;

          if (this.context[channel]) {
            var subscribe = this.context[channel];
            this._unsubscribe = subscribe(function (state) {
              _this2.setState({
                externalProps: state
              });
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this._unsubscribe) this._unsubscribe();
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            externalProps: this.state.externalProps
          }), this.props.children);
        }
      }]);

      return WithExternalProps;
    }(_react.Component);

    WithExternalProps.propTypes = (0, _lodash2.default)(WrappedComponent.propTypes, ['externalProps']);
    WithExternalProps.defaultProps = (0, _lodash2.default)(WrappedComponent.defaultProps, ['externalProps']);
    WithExternalProps.contextTypes = contextTypes;
    WithExternalProps.displayName = 'WithExternalProps(' + WrappedComponent.displayName + ')';
    return WithExternalProps;
  };
};